import React, { useState, useCallback } from 'react';
import './TeamScreen.css';

import Quotes from './media/Quotes.svg'
import Yarik from './media/Yarik.png'
import Polina from './media/Polina.png';
import CloseIcon from './media/CloseIcon.png';
import DiplomaImage from './media/diplom.png';
// Компонент модального окна информации о гранте
const GrantPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="grant-popup-overlay">
      <div className="grant-popup">
        <button className="grant-popup-close" onClick={onClose}>
          <img src={CloseIcon} alt="Закрыть" />
        </button>
        
        <div className="grant-header">
          <h3>Информация о гранте</h3>
          <p>КОНКУРС «СТУДЕНЧЕСКИЙ СТАРТАП» (ОЧЕРЕДЬ V) Это конкурс 2024 года. Участвовало около 6 000 различных проектов. Из федерального бюджета победителю выделяется 1 000 000 рублей на реализацию своей бизнес идеи. Я участвовала в направлении «Креативные индустрии»</p>
        </div>
        
        <div className="grant-image">
          <div className="grant-placeholder"></div>
          {/* Замените на реальное изображение диплома */}
          <img src={DiplomaImage} alt="Диплом" className="diploma-img" />
        </div>
      </div>
    </div>
  );
};

const TeamScreen = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [startX, setStartX] = useState(0);
  const [showGrantPopup, setShowGrantPopup] = useState(false); // Состояние для попапа
  
  const slides = [
    {
      title: "Ярослав Тихоньких",
      subtitle: "Frontend-разработчик",
      text: "Специалист IT-сферы, занимается созданием ПО для разработки веб и десктоп-приложений, включая уникальные решения для управления коллективами. Опыт более 7 лет в создании автоматических измерительных систем и интеграции образовательных и VR технологий, безграничная техническая экспертиза. Выпускник СПбГМТУ и ЛЭТИ, обширные знания в области инженерной защиты окружающей среды и управления современными предприятиями.",
      image: Yarik
    },
    {
      title: "Юлия Людвиновская",
      subtitle: "UX/UI дизайнер",
      text: "Занимается проектированием и дизайном сложных десктопных приложений, а также сайтов и лендингов. Разрабатывает интуитивно понятные интерфейсы, которые привлекают своей эстетикой и удобством. Работает над улучшением пользовательского опыта, что повышает концерсию продукта. Реализовано более 90 проектов, среди клиентов — строительные компании, страховые компании, рекламные агентства. Опыт работы в дизайне — более 14 лет. Имеет два высших образования: СПбПУ Политех и РГПУ им. Герцена.",
      image: Yarik
    },
    {
      title: "Денис Резников",
      subtitle: "Backend-разработчик",
      text: "Имеет опыт написания платформ, сайтов, приложений. Выпускник СПбГМТУ.",
      image: Yarik
    }
  ];

  const handleTouchStart = useCallback((e) => {
    setStartX(e.touches[0].clientX);
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!startX) return;
    
    const currentX = e.touches[0].clientX;
    const diffX = startX - currentX;

    if (Math.abs(diffX) > 50) {
      if (diffX > 0) {
        setCurrentIndex(prev => 
          prev === slides.length - 1 ? 0 : prev + 1
        );
      } else {
        setCurrentIndex(prev => 
          prev === 0 ? slides.length - 1 : prev - 1
        );
      }
      setStartX(0);
    }
  }, [startX, slides.length]);

  return (
    <div className="team-screen">
      {/* Добавляем попап */}
      <GrantPopup 
        isOpen={showGrantPopup} 
        onClose={() => setShowGrantPopup(false)} 
      />
      
      <h2 className="slider-title">Динамику создают <span style={{ color: '#5196FF' }}>профессионалы</span></h2>
      <img src={Polina} alt="screen2" />

      <div className="polina-case">
        <h3>Полина Шарафутдинова </h3>
        <p>Основатель и методолог проекта</p>
      </div>
      
      <div className="cardContainer">
        <p className="cardText">Научный эксперт в области социологии, имеет опыт работы научным исследователем. Работает в оценке персонала крупного холдинга со штатом более 100 тысяч работников. Лично курирует, модифицирует и адаптирует методологическую базу проекта.</p>
      </div>
      
      <img src={Quotes} alt="screen2" className='Quotes' />    
      
      <p className='polina-text'>В 17 лет, после 7 лет академического художественного образования, я не знала, чем хочу заниматься в жизни. И внезапно я увлеклась социологией, в которую влюбилась раз и навсегда. <br/><br/> Более 4 лет я вела научную деятельность в области социологии и социальной психологии. Получила красный диплом по специальности «Социология деловых коммуникаций». Имею научные публикации, выступаю на научных конференциях, участвую и побеждаю в международных конкурсах, провела десятки научных исследований.</p>
      
      <p className='polina-text'>Сейчас я занимаюсь оценкой персонала, которая идеально совместила в себе страсть к исследованиям и любовь к людям. Профессионально оцениваю персонал от генеральных директоров до рабочих. Курирую проекты единовременной оценки более 55 тысяч сотрудников. <br/><br/>Безграничная любовь к своей работе вдохновила меня на «Динамика». Я хотела создать приложение, которое позволило бы сотрудникам работать в комфортной обстановке, а руководителям лучше знать своих сотрудников. Вера в свое дело позволила мне выиграть <span className="grant-link" onClick={() => setShowGrantPopup(true)}>грант на 1 000 000 рублей</span> для воплощения моих идей в жизнь.</p>
      
      <div className="slider-container3">
        <div 
          className="slider3"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={() => setStartX(0)}
        >
          <div className="slides-wrapper3">
            {slides.map((slide, index) => (
              <div 
                key={index} 
                className={`slide3 ${index === currentIndex ? 'active' : ''}`}
                style={{
                  transform: `translateX(${(index - currentIndex) * 300}px)`,
                  zIndex: index === currentIndex ? 2 : 1
                }}
              >
                <img src={slide.image} alt={slide.title} />
                <h3>{slide.title}</h3>
                <p className="subtitle3">{slide.subtitle}</p>
                <p className="text3">{slide.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamScreen;